module.exports = __webpack_public_path__ + "img/Cuidado tóxico.3dea3d83.webp";